import React from 'react';
import { Divider, Grid, Icon, IconButton, Typography } from '@material-ui/core';


import { HomeContext } from '../../HomeContext';
import { PageLocation } from '../../../../shared/enum/PageLocation';
import { AuthContext } from '../../../Authentication/AuthContext';
import { MenuItems } from '../../enums/MenuItems';
import MenuItemComponent from '../MenuItemComponent';
import FAQ from '../../../../assets/Clients/Ambev/faq.pdf';

interface MenuInterface {
    toggleDrawer: (open: boolean, pageLocation: PageLocation | null) => (event: React.KeyboardEvent | React.MouseEvent) => void,
}
export default function MenuInfluencer({ toggleDrawer }: MenuInterface) {
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const clientListEnable: any = homeContext.influencerListClientEnable;
    const [menuItemOpen, setMenuItemOpen] = React.useState<MenuItems>(MenuItems.NONE);
    const handleClickHeaderMenu = (item: number) => {
        if (item === menuItemOpen)
            setMenuItemOpen(MenuItems.NONE);
        else
            setMenuItemOpen(item);
    };
    return (
        <>
            {clientEnable ? (
                <>
                    {authContext.login.user.profile?.functionalities && (
                        <>
                            {authContext.login.user.profile?.functionalities.findIndex(
                                f => f.description == 'Cadastro de influencers' ||
                                    f.description == 'Classificação de influencers' ||
                                    f.description == 'Acesso ao Dash Influencers') >= 0 && (
                                    <>
                                        <MenuItemComponent
                                            key="influencer-home"
                                            principalItemTitle={authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Classificação') >= 0 ? 'Influenciadores Inicio' : 'Home'}
                                            toggleDrawer={toggleDrawer}
                                            onClickPrincipalItem={toggleDrawer(false, PageLocation.INFLUENCER_HOME)}
                                        />
                                        <Divider />
                                    </>
                                )}
                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Cadastro de influencers' || f.description == 'Classificação de influencers') >= 0 && (
                                <>
                                    <MenuItemComponent
                                        key="influencer-menu"
                                        principalItemTitle="Influenciadores"
                                        toggleDrawer={toggleDrawer}
                                        isOpen={menuItemOpen === MenuItems.INFLUENCER}
                                        openPrincipalItem={() => handleClickHeaderMenu(MenuItems.INFLUENCER)}
                                        children={[
                                            {
                                                title: 'Classificação',
                                                pageLocation: PageLocation.INFLUENCER_HISTORY,
                                                show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Classificação de influencers') >= 0
                                            },
                                            {
                                                title: 'Submissão de perfil',
                                                pageLocation: PageLocation.INFLUENCER_UPLOAD,
                                                show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Cadastro de influencers') >= 0
                                            },
                                            {
                                                title: 'FAQ',
                                                pageLocation: PageLocation.FAQ,
                                                event: () => {
                                                    window.open(FAQ, '_blank');
                                                },
                                                show: authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Cadastro de influencers' || f.description == 'Classificação de influencers') >= 0
                                            },
                                        ]} />
                                    <Divider />
                                </>
                            )}
                            {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso ao Dash Influencers') >= 0 && (
                                <>
                                    <MenuItemComponent
                                        key="dashboard-menu"
                                        principalItemTitle="Dashboard"
                                        toggleDrawer={toggleDrawer}
                                        onClickPrincipalItem={toggleDrawer(false, PageLocation.DASHBOARD_INFLUENCER)} />
                                    <Divider />
                                </>
                            )}
                            <>
                                {clientListEnable.length > 1 && (
                                    <>
                                        {authContext.login.user.profile?.functionalities && (
                                            <>
                                                {authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Acesso Inicial Influencers') >= 0 && (
                                                    <>
                                                        <MenuItemComponent
                                                            key="dashboard-menu"
                                                            principalItemTitle="Seleção de Cliente"
                                                            toggleDrawer={toggleDrawer}
                                                            onClickPrincipalItem={toggleDrawer(false, PageLocation.INFLUENCER_CLIENT_SELECT)} />
                                                        <Divider />
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        </>
                    )}
                </>
            )

                : (<></>)}
        </>
    );
}